import styled from 'styled-components';

export const FloatingMenuWrapper = styled.div`
  position: absolute;
  top: 0;
`;

export const TabContainer = styled.div`
  padding: 35px 0;
  box-shadow: inset 0px 10px 20px rgba(0, 0, 0, 0.05);
  background: ${({ theme }) => theme.defaultColors.lighterGrey};
`;

export const TabMenuFixed = styled.div<{ isTransparent: boolean }>`
  transition: 0.3s;
  pointer-events: ${({ isTransparent }) => (isTransparent ? 'none' : 'auto')};
  padding-top: 10px;
  position: fixed;
  top: 0;
  left: 0;
  background: white;
  z-index: 10;
  width: 100%;
  opacity: ${({ isTransparent }) => (isTransparent ? 0 : 1)};
  box-shadow: 0px 10px 20px #0000000d;
  border-bottom: 1px solid #e2e2e2;
`;
